import { UIOrderExtras, UIPriceBreakdown } from "@flights/types";
import { objectUtils } from "@flights/web-api-utils-universal";

export const transformDisclaimersForExtras = (extras: UIOrderExtras): string[] =>
  objectUtils
    .getObjectKeys(extras)
    // extract price breakdowns from extras
    .reduce<UIPriceBreakdown[]>((acc, extraKey) => {
      if (extras[extraKey]) {
        if (extraKey === "specialBag") {
          acc.push(...extras[extraKey]?.map((specialBag) => specialBag.price));
        } else {
          acc.push(extras[extraKey].price);
        }
      }

      return acc;
    }, [])
    // extract disclaimers from price breakdown
    .flatMap((priceBreakdown) => transformDisclaimersForPriceBreakdown(priceBreakdown));

export const transformDisclaimersForPriceBreakdown = (priceBreakdown?: UIPriceBreakdown): string[] => {
  return (priceBreakdown?.bcomPricingItems || [])?.reduce<string[]>((acc, bcomPricingItem) => {
    if (bcomPricingItem.disclaimer?.trim()) {
      acc.push(bcomPricingItem.disclaimer.trim());
    }

    return acc;
  }, []);
};
